import debounce from "lodash.debounce"
import { useSWRConfig } from "swr"
import API from "./api"
import useRESTResource from "./useRESTResource"

export default function useMapTile({
  tileFetchParams,
  shouldResetOverview = false,
}) {
  const { id, overviewKey, parentKeys = [] } = tileFetchParams

  const path = id ? `${overviewKey}/tile_maps/${id}` : null

  const { cache, mutate } = useSWRConfig()
  const { data } = useRESTResource({
    path,
    only: ["show", "update", "destroy"],
  })

  const resetAndUpdateMap = debounce(
    async () => {
      for (const key of parentKeys) {
        await mutate(key, API.get(key))
      }
    },
    100,
    { leading: true }
  )
  async function update(params) {
    await data.update(params)

    if (shouldResetOverview) {
      shouldResetOverview = false
      resetAndUpdateMap()
      cache.delete(path)
    }
  }

  async function destroy() {
    await data.destroy()
    for (const key of parentKeys) {
      mutate(key)
    }
  }

  return { ...data, update, destroy }
}
